export const environment = {
    APP_NAME: "cantrak",
    logLevel: 'warn',
    production: true,
    stage: false,
    v3: false,
    appVersion: '2.0.111',
    origin: "https://q3p6xa9cg7.execute-api.ap-southeast-1.amazonaws.com/prod",
    appUrl: "https://app.cantrak.tech",
    appUrl2: "https://reports.cantrak.tech",
    socketOrigin: "wss://j81finpn5a.execute-api.ap-southeast-1.amazonaws.com/prod",
    bucketUrl: "https://cantrak-resources.s3.ap-southeast-1.amazonaws.com",
    cdnUrl: "https://resources.cantrak.tech",
    vapidKey: "BOzsXXXrUGlDcSb-eg1G4mFiHTdP2Ui2zkAR3Lkohmqigxq_92bMPAPnEdAEhVBQPlPiM5kZXvr6WYcwi_G-skc",
    googleClientId: "423057939767-4smipfn7q9qfmvn8p9ku121ch4kmmned.apps.googleusercontent.com",
    lazadaAppKey: "116220"
};
